import {cloneElement} from 'react';

export const cloneElementWithCustomProps = (element, customProps) => cloneElement(element, {
  ...element.props,
  ...customProps,
}
);

export const getNavMenuButtonAriaProps = ({isOpen, id, ariaLabel}) => {
  const ariaProps = {
    id,
    'aria-haspopup': true,
    'aria-expanded': isOpen,
  };
  if (ariaLabel) ariaProps['aria-label'] = `Toggle ${ariaLabel} Popup`;
  return ariaProps;
};

export const FOCUSABLE_SELECTOR =
  ['a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input[type="text"]:not([disabled])',
    'input[type="radio"]:not([disabled])',
    'input[type="checkbox"]:not([disabled])',
    'select:not([disabled])', '[tabindex]:not([tabindex="-1"])'].join(', ');
